import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import SecuredPage from 'Views/Components/Security/SecuredPage';

import NavigationWrapper from '../Components/Navigation/NavigationWrapper';
import BookingCardList from '../Components/_HumanWritten/Bookings/BookingsList/BookingCardList';
import { WhiteBackground } from '../Components/_HumanWritten/WhiteBackground';
import { BOOKINGS_CUSTOMER_PAGE_TITLE, CUSTOMER_BOOKINGS_PAGE_TITLE } from 'ConstantPageNames';

function BookingsPage() {
	useEffect(() => {
		document.title = BOOKINGS_CUSTOMER_PAGE_TITLE;
		if (window.loginData) {
			const { userName } = window.loginData;
			if (
				userName &&
				(userName?.startsWith('staff@') || userName?.startsWith('admin@') || userName?.startsWith('manager@'))
			) {
				document.title = CUSTOMER_BOOKINGS_PAGE_TITLE;
			}
		}
	}, []);

	return (
		<SecuredPage
			groups={['Super Administrators', 'User', 'Staff', 'Manager', 'Admin', 'InvoicedUser', 'FixedPriceUser']}
		>
			<NavigationWrapper />
			<div className="body-content">
				<WhiteBackground className="booking-cards-container">
					<BookingCardList />
				</WhiteBackground>
			</div>
		</SecuredPage>
	);
}

export default observer(BookingsPage);
